/* @flow */
import * as React from 'react';

import Text from 'components/Text';

type Props = {
  children: number,
};

export default function AdminStatisticsChartTooltipValue({ children, ...others }: Props) {
  return (
    <Text {...others} color="chalkboard" size="xlarge">
      {children.toLocaleString()}
    </Text>
  );
}
